/* eslint-disable react/no-danger */
import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import moment from 'moment';
import get from 'lodash/get';
import find from 'lodash/find';
import { Link } from 'react-router-dom';

import { navigate } from '../../../actions';
import {
  externalOfferOrderAmountPath,
  externalOfferOrderTransferPath,
  baseExternalOfferOrderPath,
  externalOfferOrderDisclosuresPath, externalOfferOrderDeliveryPath,
} from '../../Forms/Schemas/baseRrf';
import BaseConfirmationScreen from '../../BaseConfirmationScreen';
import LabeledRow from '../components/LabeledRow';
import { formatCurrency } from '../../Currency';
import { formatQuantity } from '../..//SecurityDetail/SecurityDetail';

import './styles.css';


const Component = ({
  bankLinks,
  user,
  offer,
  offerOrderAmount,
  offerOrderTransferFunds,
  history,
  resetAll,
  deliveryInformation,
}) => {
  const { isConditional } = offer;
  // Navigate to history when pressing browser back button
  window.onpopstate = () => {
    resetAll();
    history.replace('/history');
  };

  const transferBank = find(bankLinks, { bankLinkOid: offerOrderTransferFunds.from });

  let transferDetails;
  if (offerOrderTransferFunds.transferAmount) {
    transferDetails = (
      <div>
        <div styleName="breakLine" />
        <div styleName="transferDetailsLabel">Transfer Details</div>
        <LabeledRow
          label="From"
          value={transferBank.bankName}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={transferBank.bankAccountNumber}
        />
        <LabeledRow
          label="Transfer Amount"
          value={`${formatCurrency(Number.parseFloat(offerOrderTransferFunds.transferAmount))}`}
        />
        <div styleName="breakLineTotal" />
      </div>
    );
  }

  const sub = (
    <div style={{ textAlign: 'center' }}>
      Your order will remain pending until you fund the Offering Escrow Account and the investment is accepted on the
      closing date. You will receive an email with instructions on how to complete your purchase. Due to demand and&nbsp;
      <Link
        styleName="disclaimerLink"
        to={`/external-invest/${offer.id}/other-factors`}
      >
        other factors
      </Link>
      &nbsp;it is possible your investment may not get accepted.
    </div>
  );

  return (
    <BaseConfirmationScreen
      onBackClick={async () => { await resetAll(); return true; }}
      backTo="/offers"
      backLabel="View available offers"
      confirmationText="Pending Order Confirmed"
      header="Pending Order Confirmed"
      subtext={sub}
    >
      <div styleName="reviewOrderHeader">
        {offer.name}
      </div>
      <div styleName="reviewMain">
        <LabeledRow
          label="Investor Name"
          value={`${user.identity.firstName} ${user.identity.lastName}`}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label="Address"
          value={user.identity.primaryAddress.line1}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={`${user.identity.primaryAddress.city} ${user.identity.primaryAddress.state}, ${user.identity.primaryAddress.zipcode}`}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label="Date"
          value={moment().format('ll')}
          modifiedStyle="addressRow"
        />
        <div styleName="bankInfo">
          <div styleName="head">Wiring Instruction</div>
          <div styleName="table">
            <table style={{ width: '90%' }}>
              <tbody>
                <tr styleName="spaceUnder">
                  <td>Bank Name:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrBankName }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>ABA #:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrABANumber }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>A/C #:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAccountNumber }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>A/C Name:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAccountName }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>Attn:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAttentionLine }} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <LabeledRow
          label="Security Delivery Instruction:"
          value={deliveryInformation.delivery}
          modifiedStyle="addressRow"
        />
        {
          isConditional ?
            <LabeledRow
              label="Offering Category"
              value={offer.categoryName}
            /> : null
        }
        {
          isConditional ?
            <LabeledRow
              label="Share Range"
              value={`${formatCurrency(offer.minSharePrice)} - ${formatCurrency(offer.maxSharePrice)}`}
              modifiedStyle="addressRow"
            /> :
            <div>
              <LabeledRow
                label="Quantity"
                value={formatQuantity(Number.parseFloat(offerOrderAmount.quantity))}
                modifiedStyle="addressRow"
              />
              <LabeledRow
                label="Share Price"
                value={offer.pricePerShare}
                modifiedStyle="addressRow"
                isCurrency
              />
            </div>
        }
        { offerOrderTransferFunds.transferAmount ?
          transferDetails :
          <div styleName="breakLineTotal" style={{ width: '466px' }} />
        }
        <LabeledRow
          label="Total Investment"
          value={Number.parseFloat(offerOrderAmount.requestedDollarAmount)}
          modifiedStyle="addressRow"
          style={{
            fontFamily: 'Source Sans Pro',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '20px',
            lineHeight: '25px',
            letterSpacing: '0.25px',
          }}
          isCurrency
        />
      </div>
    </BaseConfirmationScreen>
  );
};

Component.displayName = 'InvestmentConfirmation';

const mapStateToProps = (state, ownProps) => ({
  bankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  investmentInfo: get(state, `investmentsByOffer[${ownProps.offer.id}]`),
  offerOrderAmount: get(state, externalOfferOrderAmountPath),
  deliveryInformation: get(state, externalOfferOrderDeliveryPath),
  offerOrderTransferFunds: get(state, externalOfferOrderTransferPath),
  user: state.user.data,
});

const mapDispatchToProps = dispatch => ({
  navigateTo: (...args) => (dispatch(navigate(...args))),
  resetAll: async () => {
    await dispatch(actions.reset(baseExternalOfferOrderPath));
    await dispatch(actions.reset(externalOfferOrderAmountPath));
    await dispatch(actions.reset(externalOfferOrderDisclosuresPath));
    await dispatch(actions.reset(externalOfferOrderTransferPath));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/InvestmentViews/InvestmentConfirmation.js